module.exports = __webpack_public_path__ + "static/img/Tasnim-Abdel-Razaq_SAPN.3a757cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/Tasnim-Abdel-Razaq_SAPN.jpg
// module id = dCWw
// module chunks = 0